// Description: This file is used to import lodash library
import _ from "lodash";
export const _lodash = _;
